/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  RESIDUAL_DRIFT_DISPERSION_DIR_1,
  RESIDUAL_DRIFT_DISPERSION_DIR_2,
  RESIDUAL_DRIFT_DISTRIBUTION_MODEL_DIR_1,
  RESIDUAL_DRIFT_DISTRIBUTION_MODEL_DIR_2,
  RESIDUAL_DRIFT_MODEL_DIR_1,
  RESIDUAL_DRIFT_MODEL_DIR_2,
  RESIDUAL_DRIFT_RECORD_TO_RECORD_DISPERSION_DIR_1,
  RESIDUAL_DRIFT_RECORD_TO_RECORD_DISPERSION_DIR_2,
  STRUCTURAL_RESPONSE_DERIVED_FROM,
  STRUCTURAL_RESPONSE_UPLOAD,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import {
  selectIsStructuralResponseMethodMatch,
  selectStructuralResponseIsSuccessByKey,
} from '#selectors/entities/models.js';
import ResponseDetail from './ResponseDetail.jsx';
import { modelTypesByForm } from '#constants/models/modelTypes/index.js';

const mapStateToProps = (state, ownProps) => {
  const { modelId, method, form, field, responseItemKey } = ownProps;
  const { selectFormFieldVisibility } = modelTypesByForm[form];

  const isMatch = selectIsStructuralResponseMethodMatch(state, {
    modelId,
    responseItemKey,
    method,
  });
  const isSuccess = selectStructuralResponseIsSuccessByKey(state, { modelId, responseItemKey });

  const showResponse = isMatch && isSuccess;
  const showUploader = selectFormFieldVisibility(state)(`${field}.${STRUCTURAL_RESPONSE_UPLOAD}`);

  const showDerivedFrom = selectFormFieldVisibility(state)(
    `${field}.${STRUCTURAL_RESPONSE_DERIVED_FROM}`
  );

  const showResidualDriftDispersionDir1 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_DISPERSION_DIR_1}`
  );

  const showResidualDriftDispersionDir2 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_DISPERSION_DIR_2}`
  );

  const showResidualDriftDistributionModelDir1 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_DISTRIBUTION_MODEL_DIR_1}`
  );

  const showResidualDriftDistributionModelDir2 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_DISTRIBUTION_MODEL_DIR_2}`
  );

  const showResidualDriftModelDir1 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_MODEL_DIR_1}`
  );

  const showResidualDriftModelDir2 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_MODEL_DIR_2}`
  );

  const showResidualDriftRecordToRecordDispersionDir1 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_RECORD_TO_RECORD_DISPERSION_DIR_1}`
  );

  const showResidualDriftRecordToRecordDispersionDir2 = selectFormFieldVisibility(state)(
    `${field}.${RESIDUAL_DRIFT_RECORD_TO_RECORD_DISPERSION_DIR_2}`
  );

  return {
    showResponse,
    showUploader,
    showDerivedFrom,
    showDir1Inputs:
      showResidualDriftDispersionDir1 ||
      showResidualDriftDistributionModelDir1 ||
      showResidualDriftModelDir1 ||
      showResidualDriftRecordToRecordDispersionDir1,
    showDir2Inputs:
      showResidualDriftDispersionDir2 ||
      showResidualDriftDistributionModelDir2 ||
      showResidualDriftModelDir2 ||
      showResidualDriftRecordToRecordDispersionDir2,
    showResidualDriftDispersionDir1,
    showResidualDriftDispersionDir2,
    showResidualDriftDistributionModelDir1,
    showResidualDriftDistributionModelDir2,
    showResidualDriftModelDir1,
    showResidualDriftModelDir2,
    showResidualDriftRecordToRecordDispersionDir1,
    showResidualDriftRecordToRecordDispersionDir2,
  };
};

export default connect(mapStateToProps)(ResponseDetail);
